"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentPanelWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var PanelDashed_1 = require("../../components/PanelDashed");
var journey_services_1 = require("@ferry/journey-services");
var commonFunctions_1 = require("../../commonFunctions");
var CheckboxWidget_1 = require("../CheckboxWidget");
var PaymentPanelWidget = /** @class */ (function (_super) {
    __extends(PaymentPanelWidget, _super);
    function PaymentPanelWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.termsAndConditionsText = "I confirm the cover I’ve chosen meets my needs and all the information I’ve given is correct. I understand that if any details I’ve given are false or inaccurate, or if we identify fraud, any claims I make could be rejected or not paid, and my insurance could be cancelled.";
        _this.renderCardsButtons = function (payUpfrontPrice) {
            var cardsButtons = [];
            var amountToPay = _this.getAmountToPay(payUpfrontPrice);
            if (_this.props.interaction.policyHolder.cardDetails && _this.props.interaction.agreeToReuseCardDetails) {
                var _loop_1 = function (cardDetails) {
                    cardsButtons.push((0, jsx_runtime_1.jsxs)("button", { className: "btn btn-primary btn-make-payment m-auto".concat(!_this.isShowTerms || _this.state.isAgreeToTerms ? "" : " btn-disabled"), onClick: function (event) { return _this.handleOnClick(event, cardDetails.number); }, id: "card-" + cardDetails.number, "aria-label": "".concat((0, commonFunctions_1.getAmountWithDecimalDigits)(amountToPay), " to pay"), children: ["Pay ".concat((0, commonFunctions_1.getAmountWithDecimalDigits)(amountToPay)), " ", (0, jsx_runtime_1.jsx)("span", { className: "payment-lock-image" })] }, cardDetails.number));
                };
                for (var _i = 0, _a = _this.props.interaction.policyHolder.cardDetails; _i < _a.length; _i++) {
                    var cardDetails = _a[_i];
                    _loop_1(cardDetails);
                }
            }
            return cardsButtons;
        };
        _this.navigateToNewPaymentCardPage = function () {
            var newCardPaymentPage = _this.getSetting("newCardPaymentPage", undefined);
            if (newCardPaymentPage) {
                _this.props.engine.navigate(newCardPaymentPage, false);
            }
        };
        _this.renderCardInformation = function () {
            var card = _this.findMainPaymentCard();
            if (card) {
                return ((0, jsx_runtime_1.jsx)("div", { className: "d-flex justify-content-center mt-3", children: (0, jsx_runtime_1.jsxs)("div", { className: "card-details-wrapper", children: [(0, jsx_runtime_1.jsx)("span", { className: "pr-2", children: _this.renderCardImage(card) }), "\u00A0", (0, jsx_runtime_1.jsx)("span", { children: _this.renderCardTypeName(card) }), "\u00A0", (0, jsx_runtime_1.jsxs)("span", { children: ["ending in ", (0, jsx_runtime_1.jsx)("b", { children: card.number.split('******')[1] })] })] }) }));
            }
            else {
                return (0, jsx_runtime_1.jsx)(React.Fragment, {});
            }
        };
        _this.getAmountToPay = function (payUpfrontPrice) {
            var amountToPay;
            if (_this.props.interaction.process === journey_services_1.INTERACTION_PROCESS_MTA_ADD_PAY_OFF_BALANCE) {
                amountToPay = _this.props.interaction.factors.payOffPremium;
            }
            else if (payUpfrontPrice && _this.props.interaction.process !== journey_services_1.INTERACTION_PROCESS_RENEWAL_PROPOSAL && _this.props.interaction.process !== journey_services_1.INTERACTION_PROCESS_MTC && _this.props.interaction.factors.monthlyPremium !== 0) {
                amountToPay = _this.props.interaction.factors.upfrontPaymentAmount;
            }
            else if (payUpfrontPrice && _this.props.interaction.process === journey_services_1.INTERACTION_PROCESS_MTC && _this.props.interaction.policyHolder.hasClaims && _this.props.interaction.factors.coolingOffExpired) {
                amountToPay = _this.props.interaction.factors.upfrontPaymentAmount;
            }
            else if (_this.props.interaction.process === journey_services_1.INTERACTION_PROCESS_RENEWAL_PROPOSAL) {
                amountToPay = _this.props.interaction.factors.premiumType === journey_services_1.PREMIUM_TYPE_ANNUAL ? _this.props.interaction.factors.annualPremium : _this.props.interaction.factors.monthlyPremium;
            }
            else {
                amountToPay = _this.props.interaction.factors.amountToPay ? _this.props.interaction.factors.amountToPay : _this.props.interaction.paymentDetails.instalmentPlan.deposit;
            }
            return amountToPay;
        };
        _this.state = {
            isAgreeToTerms: false,
        };
        _this.handleOnClick = _this.handleOnClick.bind(_this);
        _this.findMainPaymentCard = _this.findMainPaymentCard.bind(_this);
        _this.cancelChanges = _this.cancelChanges.bind(_this);
        _this.isShowTerms = _this.getSetting("isShowTerms", true);
        _this.handleOnCheckboxChange = _this.handleOnCheckboxChange.bind(_this);
        return _this;
    }
    PaymentPanelWidget.prototype.componentDidMount = function () {
        var updated = this.parseBoolean(this.props.interaction.agreeToTermsAndConditions);
        this.setState({
            isAgreeToTerms: updated,
        });
    };
    PaymentPanelWidget.prototype.render = function () {
        var additionalPremium = this.props.interaction.factors.amountToPay;
        var premium = this.props.interaction.factors.premium;
        var deposit = 0;
        return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (additionalPremium !== 0 && this.renderPaymentContent()) || (premium !== 0 && this.renderPaymentContent()) || (deposit !== 0 && this.renderPaymentContent()) }));
    };
    PaymentPanelWidget.prototype.renderPaymentContent = function () {
        var payUpfrontPrice = (this.props.interaction.uistate
            && !this.props.interaction.uistate.payFullPrice
            && this.props.interaction.product === journey_services_1.PRODUCT_WOLF_MOTOR
            && this.props.interaction.factors.premiumType !== journey_services_1.PREMIUM_TYPE_ANNUAL ||
            this.props.interaction.factors.premiumType === journey_services_1.PREMIUM_TYPE_ANNUAL
                && this.props.interaction.factors.debtAmount
                && this.props.interaction.factors.debtAmount !== 0);
        return ((0, jsx_runtime_1.jsx)(PanelDashed_1.PanelDashed, { className: "bg-white text-center pay-by-card-panel", children: this.props.interaction.agreeToReuseCardDetails
                && this.props.interaction.policyHolder.cardDetails
                && this.props.interaction.policyHolder.cardDetails.length > 0 ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "panel-dashed-contents card-information", children: this.renderCardInformation() }), (0, jsx_runtime_1.jsx)("div", { className: "pb-2 or-divider", children: " OR" }), (0, jsx_runtime_1.jsx)("div", { className: "simple-link no-outline use-different-cart-link", id: "changeCard", role: "link", "aria-label": "Use a different card to pay", onClick: this.navigateToNewPaymentCardPage, tabIndex: 0, children: "Use a different card" }), this.isShowTerms && this.renderTermsAndConditions(), (0, jsx_runtime_1.jsxs)("div", { className: "panel-dashed-contents card-buttons", children: [(0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-white mb-0 w-100 btn-margin-top-55", onClick: this.cancelChanges, id: "cancelChanges", children: "Cancel changes" }), this.renderCardsButtons(payUpfrontPrice)] })] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [this.isShowTerms && this.renderTermsAndConditions(), (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-white mb-0 w-100 btn-margin-top-55", onClick: this.cancelChanges, id: "cancelChanges", children: "Cancel changes" }), (0, jsx_runtime_1.jsxs)("button", { className: "btn btn-primary btn-make-payment m-auto".concat(!this.isShowTerms || this.state.isAgreeToTerms ? "" : " btn-disabled"), onClick: this.navigateToNewPaymentCardPage, id: "pay-with-new-card", children: [payUpfrontPrice ? "Pay ".concat((0, commonFunctions_1.getAmountWithDecimalDigits)(this.props.interaction.factors.upfrontPaymentAmount)) :
                                "Pay ".concat((0, commonFunctions_1.getAmountWithDecimalDigits)(this.props.interaction.factors.amountToPay), " "), (0, jsx_runtime_1.jsx)("span", { className: "payment-lock-image" })] })] })) }));
    };
    PaymentPanelWidget.prototype.renderTermsAndConditions = function () {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("h2", { className: "terms-conditions-title", children: "Terms and Conditions" }), (0, jsx_runtime_1.jsx)(CheckboxWidget_1.default, { callback: this.handleOnCheckboxChange, defaultValue: this.props.interaction.agreeToTermsAndConditions, label: this.termsAndConditionsText })] }));
    };
    PaymentPanelWidget.prototype.handleOnClick = function (event, cardNumber) {
        var interaction = this.props.engine.getInteraction();
        var paymentDetails = interaction.paymentDetails;
        paymentDetails.cardNumber = cardNumber;
        this.props.engine.callInteractionSetState(__assign(__assign({}, this.props.engine.getInteraction()), { paymentDetails: paymentDetails }));
        this.executeEvent('click');
        event.preventDefault();
    };
    PaymentPanelWidget.prototype.renderCardImage = function (card) {
        if (card.type.includes("VISA")) {
            return (0, jsx_runtime_1.jsx)("img", { className: "payment-icon", alt: "Visa icon", src: "/img/visa-icon.svg" });
        }
        if (card.type.includes("MASTERCARD")) {
            return (0, jsx_runtime_1.jsx)("img", { className: "payment-icon", alt: "Mastercard icon", src: "/img/mastercard-icon.svg" });
        }
        return (0, jsx_runtime_1.jsx)(React.Fragment, {});
    };
    ;
    PaymentPanelWidget.prototype.renderCardTypeName = function (card) {
        if (card.type.includes("VISA")) {
            return "Visa";
        }
        if (card.type.includes("MASTERCARD")) {
            return "Mastercard";
        }
        return "";
    };
    ;
    PaymentPanelWidget.prototype.findMainPaymentCard = function () {
        var interaction = this.props.interaction;
        if (interaction.agreeToReuseCardDetails && interaction.policyHolder.cardDetails) {
            return interaction.policyHolder.cardDetails[0];
        }
        return null;
    };
    PaymentPanelWidget.prototype.parseBoolean = function (value) {
        return value === "true" || (typeof value === 'boolean' && value);
    };
    PaymentPanelWidget.prototype.cancelChanges = function () {
        window.location.href = "/dashboard/annualMotor/yourCars/".concat(this.props.interaction.agreementNumber);
    };
    PaymentPanelWidget.prototype.handleOnCheckboxChange = function (event) {
        this.setState({
            isAgreeToTerms: event.target.checked,
        });
    };
    return PaymentPanelWidget;
}(plugin_journey_1.WidgetBase));
exports.PaymentPanelWidget = PaymentPanelWidget;
//# sourceMappingURL=PaymentPanelWidget.js.map